/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiAssignmentUser } from './InternalApiAssignmentUser';
import {
    InternalApiAssignmentUserFromJSON,
    InternalApiAssignmentUserFromJSONTyped,
    InternalApiAssignmentUserToJSON,
    InternalApiAssignmentUserToJSONTyped,
} from './InternalApiAssignmentUser';
import type { InternalApiPersonStatus } from './InternalApiPersonStatus';
import {
    InternalApiPersonStatusFromJSON,
    InternalApiPersonStatusFromJSONTyped,
    InternalApiPersonStatusToJSON,
    InternalApiPersonStatusToJSONTyped,
} from './InternalApiPersonStatus';

/**
 * 
 * @export
 * @interface InternalApiPersonStatusEvent
 */
export interface InternalApiPersonStatusEvent {
    /**
     * 
     * @type {number}
     * @memberof InternalApiPersonStatusEvent
     */
    id?: number;
    /**
     * 
     * @type {InternalApiAssignmentUser}
     * @memberof InternalApiPersonStatusEvent
     */
    assigner?: InternalApiAssignmentUser;
    /**
     * 
     * @type {InternalApiPersonStatus}
     * @memberof InternalApiPersonStatusEvent
     */
    status: InternalApiPersonStatus;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiPersonStatusEvent
     */
    startTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiPersonStatusEvent
     */
    endTime?: Date;
}

/**
 * Check if a given object implements the InternalApiPersonStatusEvent interface.
 */
export function instanceOfInternalApiPersonStatusEvent(value: object): value is InternalApiPersonStatusEvent {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    return true;
}

export function InternalApiPersonStatusEventFromJSON(json: any): InternalApiPersonStatusEvent {
    return InternalApiPersonStatusEventFromJSONTyped(json, false);
}

export function InternalApiPersonStatusEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiPersonStatusEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'assigner': json['assigner'] == null ? undefined : InternalApiAssignmentUserFromJSON(json['assigner']),
        'status': InternalApiPersonStatusFromJSON(json['status']),
        'startTime': (new Date(json['startTime'])),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
    };
}

export function InternalApiPersonStatusEventToJSON(json: any): InternalApiPersonStatusEvent {
    return InternalApiPersonStatusEventToJSONTyped(json, false);
}

export function InternalApiPersonStatusEventToJSONTyped(value?: InternalApiPersonStatusEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assigner': InternalApiAssignmentUserToJSON(value['assigner']),
        'status': InternalApiPersonStatusToJSON(value['status']),
        'startTime': value['startTime'].toISOString(),
        'endTime': value['endTime'] == null ? value['endTime'] : value['endTime'].toISOString(),
    };
}

